export default __webpack_public_path__ + "static/media/upload-doc-icon.9da0ec88.svg";